import React, { Component } from 'react';
import { bool, date, object, string } from 'prop-types';
import { shortDateString } from 'ps-components/lib/formatters';
import './PdfCoverPage.scss';

class PdfCoverPage extends Component {
  static propTypes = {
    customHeader: string,
    lastModifiedDate: date,
    dataAgedToDate: date,
    lastModifiedName: string,
    reportName: string,
    selectedJob: object,
    showLastModified: bool
  };

  render() {
    const {
      customHeader,
      selectedJob,
      showLastModified,
      reportName,
      lastModifiedDate,
      lastModifiedName,
      dataAgedToDate
    } = this.props;
    const lastModifiedFormattedDate = lastModifiedDate
      ? shortDateString(new Date(lastModifiedDate.replace(/-/g, '/')))
      : null;
    const hasAllData = lastModifiedName && lastModifiedDate;
    const hasNoData = !lastModifiedDate && !lastModifiedFormattedDate;
    const auditMessage =
      (showLastModified && hasNoData) || !showLastModified
        ? ''
        : showLastModified && hasAllData
        ? `Last modified by ${lastModifiedName} on ${lastModifiedFormattedDate}`
        : `Last modified on ${lastModifiedFormattedDate}`;

    return (
      <div>
        <div className="pdf-cover-page">
          <div className="pdf-cover-page__custom-header pxl-header-small">{customHeader ? customHeader : ''}</div>
          <div className="pdf-cover-page__report-name pxl-header-xsmall">
            {reportName ? reportName : 'Position Compensation Summary of'}
          </div>
          <div className="pdf-cover-page__job-title pxl-header-small">{selectedJob.title}</div>
          <div className="pdf-cover-page__job-image">
            <img
              alt="MarketPay Logo"
              className="comp-sum-content__pdf-page-footer-logo"
              src="/view/static/mp/images/4x4_dot.svg"
            />
          </div>
          <div className="pdf-cover-page__report-data">
            <div className="pdf-cover-page__report-data-aging pxl-text-xxsmall">
              {dataAgedToDate && `All data aged to ${shortDateString(new Date(dataAgedToDate.replace(/-/g, '/')))}`}
            </div>
            {showLastModified && (
              <div className="pdf-cover-page__report-data-last-modified pxl-text-xxsmall">{auditMessage}</div>
            )}
            <div className="pdf-cover-page__report-data-report-data pxl-text-xxsmall">
              Report Date: {shortDateString(new Date())}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PdfCoverPage;
